import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
const NAV_ITEMS = [{
  href: '/aplikacje',
  label: 'Aplikacje'
}, {
  href: '/zespol',
  label: 'Zespół'
}, {
  href: '/partnerzy',
  label: 'Partnerzy'
}, {
  href: '/o-nas',
  label: 'O nas'
}];
export function SiteFooter() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-algoprimary/60 to-transparent" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-3"><span className="font-bold text-contentPrimary text-lg tracking-tight">Algolabs</span><p className="max-w-xs text-contentTertiary text-sm leading-relaxed">Inkubator startupów edukacyjnych — część AlgoAcademy.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-mono text-contentTertiary text-xs uppercase tracking-widest">Nawigacja</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-3">{t2}<ul className="flex flex-col gap-2">{NAV_ITEMS.map(_temp)}</ul></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-6 py-16 sm:grid-cols-3">{t1}{t3}<div className="flex flex-col gap-3"><span className="font-mono text-contentTertiary text-xs uppercase tracking-widest">Połącz się</span><a href="https://www.algoacademy.pl" className="inline-flex min-h-11 w-fit items-center rounded-md text-contentSecondary text-sm transition-colors hover:text-contentPrimary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary sm:min-h-0">algoacademy.pl</a></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <footer className="relative border-borderPrimary border-t bg-backgroundSecondary">{t0}{t4}<div className="border-borderPrimary border-t"><div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-6 py-6 text-contentTertiary text-xs sm:flex-row sm:items-center sm:justify-between"><p>© {new Date().getFullYear()} Algolabs. Wszystkie prawa zastrzeżone.</p><p>algolabs.pl</p></div></div></footer>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(item) {
  return <li key={item.href}><Link href={item.href} className="inline-flex min-h-11 items-center rounded-md text-contentSecondary text-sm transition-colors hover:text-contentPrimary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary sm:min-h-0">{item.label}</Link></li>;
}